import { marketAPIController } from '@aqx-core/common/api/market';
import { EOrderType } from '@aqx-core/common/api/order';

import { DEFAULT_ORDER_TYPE_FILTER_OPTIONS } from './constants';
import { assetsFilterService } from './service';

class AssetsFilterViewController {
  public async getSymbolCategories() {
    await marketAPIController.getMarketSymbolCategories({
      onSuccess: (result) => {
        const symbolTypeList = result?.symbolTypeList ?? [];
        assetsFilterService.setSymbolCategories(symbolTypeList);
      },
      onError: () => {}
    });
  }

  public async initFilterOptions() {
    await this.getSymbolCategories();
    assetsFilterService.setLoading(false);
  }

  public updateAvailableOrderTypes(orders: Array<{ orderType?: EOrderType }>) {
    const uniqueOrderTypes = new Set(orders.map((order) => order.orderType));
    const availableTypes = DEFAULT_ORDER_TYPE_FILTER_OPTIONS.filter((type) => uniqueOrderTypes.has(type));
    assetsFilterService.setAvailableOrderTypes(availableTypes);
  }
}

export const assetsFilterViewController = new AssetsFilterViewController();
